export function HowItWorks() {
  const steps = [
    {
      number: '01',
      title: 'Download & Install',
      description: 'Download the TRAMETAL VPN application on your device. Installation takes just a few minutes and works on all major platforms including Windows, Mac, iOS, and Android.',
      icon: 'ri-download-cloud-line'
    },
    {
      number: '02',
      title: 'Create Your Account',
      description: 'Sign up with your email and create a secure account. Choose your preferred VPN subscription plan and complete the simple registration process.',
      icon: 'ri-user-add-line'
    },
    {
      number: '03',
      title: 'Connect & Browse Securely',
      description: 'Select a server location from our global network and click connect. Your internet connection is now encrypted and your online activities are completely private and secure.',
      icon: 'ri-shield-check-line'
    }
  ];

  return (
    <section id="how-it-works" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h3 className="text-4xl font-bold text-gray-900 mb-4">
            How <strong>TRAMETAL VPN</strong> Works
          </h3>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Get started with our <strong>VPN service</strong> in three simple steps and enjoy secure browsing within minutes.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-12">
          {steps.map((step, index) => (
            <div key={index} className="relative">
              <div className="text-center">
                <div className="inline-flex w-20 h-20 items-center justify-center bg-teal-600 rounded-full mb-6">
                  <i className={`${step.icon} text-4xl text-white`}></i>
                </div>
                <div className="text-6xl font-bold text-teal-100 mb-4">
                  {step.number}
                </div>
                <h4 className="text-2xl font-bold text-gray-900 mb-4">
                  <a href="#how-it-works" className="hover:text-teal-600 transition-colors">
                    {step.title}
                  </a>
                </h4>
                <p className="text-gray-600 leading-relaxed">
                  {step.description}
                </p>
              </div>
              {index < steps.length - 1 && (
                <div className="hidden md:block absolute top-10 left-full w-full h-0.5 bg-teal-200 -translate-x-1/2" style={{ width: 'calc(100% - 5rem)' }}></div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}